const displayType = {
    DISPLAY_TYPE_DIAL : 'DIAL',

    DISPLAY_TYPE_BAR_CHART : 'BAR_CHART',

    DISPLAY_TYPE_LINE_CHART : 'LINE_CHART',

    DISPLAY_TYPE_PIE_CHART : 'PIE_CHART'

};

angular.module('gw-um-j2js')
    .constant('displayType', displayType);